export enum VendorPendingAction {
  none = "None",
  quotationRequests = "QuotationRequests",
  assignedWork = "AssignedWork",
  completedRepairs = "CompletedRepairs",
  inProgress = "InProgress",
  pendingPayments = "PendingPayments",
  archived = "Archived",
  quotationExpired = "QuotationExpired"
}
